import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Nouvelle vente", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  class: "default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0",
  type: "button"
}, [
  /*#__PURE__*/_createTextVNode(" Export "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mot clé ", -1)
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date Debut ", -1)
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date Fin ", -1)
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Client ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_23 = { class: "table-responsive" }
const _hoisted_24 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " # "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " date "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " client "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " montant "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " montant sans epargne "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, " Actions ")
  ])
], -1)
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_30 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_31 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_32 = { class: "dropdown" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_34 = { class: "dropdown-menu" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "3",
  class: "text-end"
}, " Total : ", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_51 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_52 = {
  class: "modal fade createNewModal",
  id: "MyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_53 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_54 = { class: "modal-content p-15 p-md-40" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title fw-bold text-black" }, "Détails")
], -1)
const _hoisted_56 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_57 = { class: "table-responsive" }
const _hoisted_58 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("th", null, " DATE ", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("th", null, " MONTANT ", -1)
const _hoisted_62 = { key: 0 }
const _hoisted_63 = {
  class: "table text-nowrap align-middle mb-0",
  style: {"width":"100%"}
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, " # "),
  /*#__PURE__*/_createElementVNode("th", null, " PRODUIT "),
  /*#__PURE__*/_createElementVNode("th", null, " PRIX "),
  /*#__PURE__*/_createElementVNode("th", null, " QTE "),
  /*#__PURE__*/_createElementVNode("th", null, " MONTANT ")
], -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close shadow-none",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_66 = {
  class: "modal fade createNewModal",
  id: "MyModalReglement",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_67 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_68 = { class: "modal-content p-15 p-md-40" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title fw-bold text-black" }, "Détails Reglement")
], -1)
const _hoisted_70 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_71 = { class: "table-responsive" }
const _hoisted_72 = { class: "table text-nowrap bg-default align-middle mb-0" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("th", null, " CLIENT ", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("th", null, " VENTE ", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("th", null, " TOTAL REGLER ", -1)
const _hoisted_77 = { key: 0 }
const _hoisted_78 = {
  class: "table text-nowrap align-middle mb-0",
  style: {"width":"100%"}
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, " # "),
  /*#__PURE__*/_createElementVNode("th", null, " DATE "),
  /*#__PURE__*/_createElementVNode("th", null, " MONTANT "),
  /*#__PURE__*/_createElementVNode("th", null, " MONTANT RESTANT ")
], -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close shadow-none",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          class: "search-box position-relative",
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, null, 32),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/Ajout-Vente",
            class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          }),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_Field, {
                  style: {"max-height":"42px"},
                  modelValue: _ctx.searchTerm,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event)),
                  onKeyup: _ctx.rechercher,
                  name: "mot",
                  type: "text",
                  "aria-disabled": "true",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Recherche par mot clé"
                }, null, 8, ["modelValue", "onKeyup"])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_Field, {
                  name: "dateDebut",
                  type: "date",
                  modelValue: _ctx._dateDebut,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx._dateDebut) = $event)),
                  value: _ctx.getCurrentDate(),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["modelValue", "value"]),
                _createVNode(_component_ErrorMessage, {
                  name: "dateDebut",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_Field, {
                  name: "dateFin",
                  type: "date",
                  modelValue: _ctx._dateFin,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx._dateFin) = $event)),
                  value: _ctx.getCurrentDate(),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["modelValue", "value"]),
                _createVNode(_component_ErrorMessage, {
                  name: "dateFin",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createVNode(_component_Field, {
                  modelValue: _ctx._client,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx._client) = $event)),
                  name: "client"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: 
                    async (query) => {
                      const results = await _ctx.searchClient(query);
                      if (results && results.length > 0) {
                        return results;
                      } else if (query.length >= 3) {
                        return [
                          { value: '', label: 'Aucun enregistrement trouvé' },
                        ];
                      } else {
                        return [];
                      }
                    },
                      noOptionsText: "Tapez au moins deux caractères",
                      "filter-results": false,
                      "min-chars": 3,
                      delay: 0,
                      searchable: true,
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { placeholder: "Sélectionner un client" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "client",
                  class: "text-danger"
                })
              ])
            ])
          ])
        ]),
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("table", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (vente, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_26, _toDisplayString(vente.id), 1),
                  _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.formatDate(vente.dateVente)), 1),
                  _createElementVNode("td", _hoisted_28, _toDisplayString('[ '+vente.client.code+' ] '+vente.client.prenoms+ ' ' + vente.client.nom), 1),
                  _createElementVNode("td", _hoisted_29, _toDisplayString(vente.montant), 1),
                  _createElementVNode("td", _hoisted_30, _toDisplayString((vente.montant)? vente.montantSansEpargne : '-'), 1),
                  _createElementVNode("td", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("ul", _hoisted_34, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#MyModal",
                            onClick: ($event: any) => (_ctx.detail(vente.id))
                          }, [
                            _hoisted_36,
                            _createTextVNode(" Détail ")
                          ], 8, _hoisted_35)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.fetchPdfUrl(vente))
                          }, [
                            _hoisted_38,
                            _createTextVNode(" Voir la fiche ")
                          ], 8, _hoisted_37)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.regenererLettreDengagement(vente.id))
                          }, [
                            _hoisted_40,
                            _createTextVNode(" Regenérer la lettre d'engagement ")
                          ], 8, _hoisted_39)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#MyModalReglement",
                            onClick: ($event: any) => (_ctx.detailReglement(vente.id))
                          }, [
                            _hoisted_42,
                            _createTextVNode(" Voir les règlements ")
                          ], 8, _hoisted_41)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.regulariserReglement(vente.id))
                          }, [
                            _hoisted_44,
                            _createTextVNode(" Régulariser le règlement ")
                          ], 8, _hoisted_43)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.genererFacture(vente.id))
                          }, [
                            _hoisted_46,
                            _createTextVNode(" Generer la facture ")
                          ], 8, _hoisted_45)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.suppression(vente.id,_ctx.elements,'vente','cette vente ?'))
                          }, [
                            _hoisted_48,
                            _createTextVNode(" Annuler cette vente ")
                          ], 8, _hoisted_47)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128)),
              _createElementVNode("tr", null, [
                _hoisted_49,
                _createElementVNode("td", null, [
                  _createElementVNode("h6", null, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.formatMontant(_ctx.total)), 1)
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("h6", null, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.formatMontant(_ctx.totalSansEpargne)), 1)
                  ])
                ]),
                _hoisted_50
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_52, [
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _hoisted_55,
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("table", _hoisted_58, [
                (_ctx.element)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_59, [
                      _createElementVNode("tr", null, [
                        _hoisted_60,
                        _createElementVNode("td", null, _toDisplayString((_ctx.element.dateVente) ? _ctx.formatDate(_ctx.element.dateVente) : ""), 1),
                        _hoisted_61,
                        _createElementVNode("td", null, _toDisplayString((_ctx.element.montant) ? _ctx.formatMontant(_ctx.element.montant) : ""), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.element)
                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                    _createElementVNode("table", _hoisted_63, [
                      _createElementVNode("tbody", null, [
                        _hoisted_64,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.element.prodCondVentes, (prod, indexx) => {
                          return (_openBlock(), _createElementBlock("tr", { key: indexx }, [
                            _createElementVNode("td", null, _toDisplayString(prod.id), 1),
                            _createElementVNode("td", null, _toDisplayString(prod.nomComplet), 1),
                            _createElementVNode("td", null, _toDisplayString(prod.prix), 1),
                            _createElementVNode("td", null, _toDisplayString(prod.qteVendu), 1),
                            _createElementVNode("td", null, _toDisplayString((prod.qteVendu * prod.prix)), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_65
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_66, [
      _createElementVNode("div", _hoisted_67, [
        _createElementVNode("div", _hoisted_68, [
          _hoisted_69,
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("table", _hoisted_72, [
                (_ctx.elementReglement)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_73, [
                      _createElementVNode("tr", null, [
                        _hoisted_74,
                        _createElementVNode("td", null, _toDisplayString(_ctx.elementReglement[0]?.vente?.client?.nom +' '+_ctx.elementReglement[0]?.vente?.client?.prenoms), 1),
                        _hoisted_75,
                        _createElementVNode("td", null, _toDisplayString('#'+_ctx.elementReglement[0]?.vente?.id), 1),
                        _hoisted_76,
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatMontant(_ctx.totalReglement)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.elementReglement)
                ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                    _createElementVNode("table", _hoisted_78, [
                      _createElementVNode("tbody", null, [
                        _hoisted_79,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elementReglement, (reg, inde) => {
                          return (_openBlock(), _createElementBlock("tr", { key: inde }, [
                            _createElementVNode("td", null, _toDisplayString(reg.id), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(reg.dateReglement)), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatMontant(reg.montant)), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatMontant(reg.restAPayer)), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_80
        ])
      ])
    ])
  ], 64))
}